module.exports = __webpack_public_path__ + "img/出库单.13e75fae.svg";